import React from 'react';
import C3Chart from 'react-c3js';

class QuickC3 extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.shouldUpdate;
    // console.log(!!nextProps.user && nextProps.user.userId !== this.props.user.userId);
    // return !!nextProps.user && nextProps.user.userId !== this.props.user.userId;
    // return false;
  }

  render() {
    // console.log('rendering');
    return <C3Chart {...this.props} />;
  }
};

export default QuickC3;



// WEBPACK FOOTER //
// ./src/components/QuickC3/QuickC3.jsx